<template>
  <div class="strip list_view">
    <div
      class="row no-gutters"
      style="cursor: pointer"
    >
      <div class="col-lg-5">
        <figure
          style="height: 100%"
          class="dark-background"
        >
          <a><img src="../../assets/img/transfers/transfer.jpg"></a>
        </figure>
      </div>
      <div class="col-lg-7">
        <div
          class="wrapper"
          style="padding-bottom: 0"
        >
          <h3
            class="mb-3"
            v-html="$t('lang.transfer.transfer_in', {city: cityName.toUpperCase()})"
          />

          <div class="small_info">
            <!--    UBICACIÓN    -->
            <!--            <h6 class="details_items">-->
            <!--              <i class="icon-location-2" />-->
            <!--              {{ $t('lang.stores.location') }}:-->

            <!--              <span class="small_h6">-->
            <!--                {{ booking.store.full_address }}-->

            <!--              </span>-->
            <!--            </h6>-->

            <!--    FECHA INGRESO    -->
            <h6 class="details_items">
              <i class="icon-right-big" />
              {{ $t('lang.transfer.date') }}:
              <span
                v-if="booking.date_time"
                class="small_h6"
                style="white-space: nowrap"
              >{{ formatDateToDisplay(booking.date_time, lang) }}
              </span>
              <span
                v-else
                class="small_h6"
                style="white-space: nowrap"
              >{{ formatDateToDisplay(booking.created_at, lang) }}
              </span>
            </h6>

            <!--    PAX    -->
            <h6 class="details_items">
              <i class="icon-user" />
              <span>
                {{ booking.pax }} {{ $tc('lang.transfer.passengers', booking.pax ) }}
              </span>
            </h6>

            <!--    PRECIOS    -->
            <h6 class="details_items">
              <i class=" icon-dollar" />
              {{ $t('lang.search.prices.booking_price') }}
              <span
                class="small_h6"
                style="white-space: nowrap"
              >
                <span> {{ $globalPrices[booking.currency].symbol }} </span>

                <span class="small_h6">
                  {{ Number(booking.total_price).toLocaleString('de-DE') }}
                </span>

              </span>
            </h6>

            <!--    ESTADO    -->
            <h6 class="details_items">
              <span
                :class="statusClass"
                class="badge-padding"
              >
                {{ $t('lang.bookings.status.' + booking.transfer_booking_status).toUpperCase() }}
              </span>
            </h6>
          </div>

          <h3
            v-if="booking.voucher_url != null"
            class="text-center"
            style="margin-bottom: 1rem"
          >
            <small>
              <b-link
                :href="booking.voucher_url"
                target="_blank"
              >
                {{ $t('lang.bookings.see_details') }}
              </b-link>
            </small>
          </h3>
          <div
            v-else
            class="alert alert-warning alert-dismissible"
          >
            {{ $t('lang.transfer.waiting_voucher') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cities } from '@/data/cities';
import { formatDateToDisplay } from '@/utils/dateFormatters';

export default {
  name: 'TransferBookingCard',
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lang: this.$store.state.main.lang,
    };
  },
  computed: {
    statusClass() {
      let classColor = 'none';
      const status = this.booking.transfer_booking_status;

      switch (status) {
        case 'pending':
          classColor = 'warning';
          break;
        case 'initiated':
          classColor = 'primary';
          break;
        case 'confirmed':
          classColor = 'success';
          break;
        default:
          break;
      }
      return `badge badge-pill badge-${classColor}`;
    },

    cityName() {
      const city = cities.find((data) => data.bd_city_id === this.booking.city_id);
      return this.$t(`lang.cities.${city.id}`);
    },
  },

  created() {
    if (!this.booking.voucher_url) {
      setTimeout(() => {
        if (this.$route.name.includes('Bookings')) {
          this.$router.go();
        }
      }, 10000);
    }
  },
  methods: { formatDateToDisplay },
};
</script>

<style scoped>
</style>
